// utils/formatters.js

/** Round to cents using integer math — avoids 640 → 639.99 float drift. */
export const roundMoney = (value) => {
  if (value === null || value === undefined || value === '') return '0.00';
  const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^\d.-]/g, ''));
  if (isNaN(num)) return '0.00';
  return (Math.round(num * 100) / 100).toFixed(2);
};

// Format currency values
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

// Format date to display in a readable format
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Format percentage values
export const formatPercent = (value) => {
  return `${(value * 100).toFixed(1)}%`;
};

/** Short frequency suffix for compact UI (e.g. $120/mo). */
export const abbreviateFrequency = (frequency) => {
  const labels = {
    weekly: 'wk',
    fortnightly: 'fn',
    monthly: 'mo',
    quarterly: 'qtr',
    yearly: 'yr',
  };
  return labels[frequency] || frequency;
};
